import _regeneratorRuntime from "/codebuild/output/src3305341033/src/hvorigins/node_modules/@babel/runtime/regenerator";

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

export function poll(callback, interval, count) {
  var _this = this;

  if (count > 0) {
    setTimeout(function () {
      return __awaiter(_this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var done;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return callback();

              case 2:
                done = _context.sent;
                if (!done) poll(callback, interval, count - 1);

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));
    }, interval);
  }
}
export function pollUntilReady(adapter, pollInterval, pollCount) {
  poll(function () {
    var ready = adapter.ready;

    if (ready) {
      if (!adapter.emit('ready')) {
        console.warn("".concat(adapter.constructor.name, " is ready but no listener was registered"));
      }
    }

    return ready;
  }, pollInterval, pollCount);
}